import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RegionProvider } from "../../../shared/providers/region.provider";
import { FrequencyProvider } from "../../../shared/providers/frequency.provider";
import { ChannelProvider } from "../../../shared/providers/channel.provider";
import { GeographyProvider } from "../../../shared/providers/geography.provider";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { Router } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { AdminDataProvider } from "../../../shared/providers/master-provider/admin-data.provider";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { StateProvider } from "../../../shared/providers/state.provider";
import { StateModel } from "../../../shared/models/state";
import { PosmAuditConfigurationModel } from "src/app/hubadmin/shared/models/visibility";
import { VisibilityProvider } from "src/app/hubadmin/shared/providers/visibility.provider";
import {
  NgbCalendar,
  NgbDate,
  NgbDatepicker,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { DateFormateService } from "src/app/services/date-formate.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import {
  NgWizardConfig,
  NgWizardService,
  StepChangedArgs,
  StepValidationArgs,
  STEP_STATE,
  THEME,
} from "ng-wizard";
import { of } from "rxjs";
import { USER_PONITS_HEADER } from "src/app/hubadmin/shared/models/mock-data";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ExcelModel } from "src/app/hubadmin/shared/models/geography";
import { NgxUiLoaderService } from "ngx-ui-loader";

@Component({
  selector: "app-visibility-config-add",
  templateUrl: "./visibility-config-add.component.html",
  styleUrls: ["./visibility-config-add.component.scss"],
})
export class VisibilityConfigAddComponent implements OnInit {
  fromDate: NgbDate;
  toDate: NgbDate;
  @ViewChild(NgbDatepicker, { static: false }) datePicker;
  frequencyList: any = [];
  id;
  formData: FormGroup;
  submitted: boolean = false;
  regions: any = [];
  channels: any = [];
  states: StateModel[];
  geography: any = [];
  posmElements: any = [];
  disabled: boolean = false;
  submittedLevels: any = { isSubmitted: false, state: "engagement" };
  searchText: any;
  tempOptionModel: any;
  private _parameters: any;
  AssignedUsers: any[];
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden,
  };
  isFirstOpen = true;
  isImage: boolean = true;
  outletmasterSelected: boolean = false;
  wizardButtonText = "Submit";
  sampleTemplate: any;
  headerText: string = "Add";
  mode: number = 1; //1 = add, 2=edit
  config: NgWizardConfig = {
    // selected: 0,
    anchorSettings: { anchorClickable: true },
    theme: THEME.default,
  };
  excel: ExcelModel = new ExcelModel();
  minDate: { year: number; month: number; day: number; };

  // convenience getters for easy access to form fields
  get f() {
    return this.formData.controls;
  }

  @Input()
  model: PosmAuditConfigurationModel = new PosmAuditConfigurationModel();
  posmType: any[];
  min: number;
  max: number;
  options: any[] = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    public regionProvider: RegionProvider,
    public frequencyProvider: FrequencyProvider,
    public channelProvider: ChannelProvider,
    public geographyProvider: GeographyProvider,
    private fb: FormBuilder,
    public adminDataProvider: AdminDataProvider,
    public stateProvider: StateProvider,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public router: Router,
    public formBuilder: FormBuilder,
    public visiblityProvider: VisibilityProvider,
    private ngbCalendar: NgbCalendar,
    private formateDate: DateFormateService,
    private ngWizardService: NgWizardService,
    public alertService: AlertService,
    public exportExcelService: ExportExcelService,
    private xlsx: XlsxService,
    private uploadFile: UploadZipService,
    private modalService: NgbModal,
    private ngxService: NgxUiLoaderService,
  ) {
    this.formData = this.formBuilder.group({
      posm_element_config_id: ["", Validators.required],
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
      points: ["", Validators.required],
      region_id: ["", Validators.required],
      state_code: ["", Validators.required],
      channel_id: ["", Validators.required],
      chiller_month: ["", Validators.required],
      chiller_year: ["", Validators.required]
    });

    this.posmType = [
      { id: 1, name: "Branding" },
      { id: 2, name: "Cooler" },
    ];

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

    this.config = {
      selected: 0,
      anchorSettings: { anchorClickable: true },
      theme: THEME.default,
      toolbarSettings: {
        toolbarExtraButtons: [],
      },
    };

    this.uploadFile.currentMessage.subscribe(message => {
      if (message.status == 'success') {
        this.getAssignedUsers();
      }
    })
  }
  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {
      console.log(error);
    }
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) { }
  }

  skip()
  {
    this.showNextStep();
  }

  ngOnInit() {
    this.getStateList();
    this.getYears();
    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.id = Number.parseInt(params["id"]);
          this.getPosmAuditConfig(this.id);
          this.getAssignedUsers();
          this.headerText = "Edit";
          this.mode = 2;
        }
      }
    });
  }

  ngDoCheck() {
    this.regions = this.regionProvider.regions;
    this.frequencyList = this.frequencyProvider.frequency;
    this.channels = this.channelProvider.channels;
    this.geography = this.geographyProvider.geography;
    this.posmElements = this.visiblityProvider.visibility;
    if (typeof this.posmElements != "undefined") {
      if (this.posmElements.length > 0) {
        this.posmElements = this.posmElements.filter(i => i.element_type == 1)
      }
    }
  }

  selectedElements: any[];

  onChangeType(item) {
    this.selectedElements = this.posmElements.filter(
      (i) => i.element_type == item
    );
  }

  getYears() {
    (this.min = 2019), (this.max = new Date().getFullYear());
    let options = "<option>Select Year</option>";
    for (var i = this.min; i <= this.max; i++) {
      options += '<option value="' + i + '">' + i + "</option>";
      this.options.push(i);
    }
    this.options.reverse();
  }

  getPosmAuditConfig(id) {
    this.apiService
      .getHeaders(this.apiConfig.getVisibilityConfig + "?id=" + id)
      .subscribe(
        (res: any) => {
          this.model = res.body.data as PosmAuditConfigurationModel;
          this.model.show = false;
          this.getFormModel();
          this.model.statusString = (this.model.status == 1) ? "Active" : "Inactive";
          if (new Date(this.model.start_date) >= new Date()) {
            this.model.show = true;
          }
          let dates = {
            start: this.model.start_date.split("-"),
            end: this.model.end_date.split("-"),
          };
          let startDate = {
            year: parseInt(dates.start[0]),
            month: parseInt(dates.start[1]),
            day: parseInt(dates.start[2]),
          };
          let endDate = {
            year: parseInt(dates.end[0]),
            month: parseInt(dates.end[1]),
            day: parseInt(dates.end[2]),
          };
          this.model.startDate = startDate;
          this.model.endDate = endDate;
          this.getStateList();
          this.onChangeType(this.model.posm_type);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getStateList(): void {
    this.apiService
      .getHeaders(this.apiConfig.configGetStates)
      .subscribe((res: any) => {
        this.states = res.body.data as StateModel[];
        this.states.forEach((s) => {
          s.id = s.state_code;
        });
        this.stateFilteredByRegion = this.states.filter(
          (i) => i.region_id == this.model.region_id
        );
      });
  }

  stateFilteredByRegion: StateModel[];

  onChangeRegion(item) {
    this.stateFilteredByRegion = this.states.filter(
      (s) => s.region_id == item && s.state_year == 2021
    );
  }

  setFormModel() {
    this.model.region_id = this.formData.controls['region_id'].value;
    this.model.state_code = this.formData.controls['state_code'].value;
    this.model.channel_id = this.formData.controls['channel_id'].value;
    this.model.posm_element_config_id = this.formData.controls['posm_element_config_id'].value;
    this.model.chiller_month = this.formData.controls['chiller_month'].value;
    this.model.chiller_year = this.formData.controls['chiller_year'].value;
  }

  getFormModel() {
    this.formData.controls['region_id'].setValue(this.model.region_id);
    this.formData.controls['state_code'].setValue(this.model.state_code);
    this.formData.controls['channel_id'].setValue(this.model.channel_id);
    this.formData.controls['posm_element_config_id'].setValue(this.model.posm_element_config_id);
    this.formData.controls['chiller_month'].setValue(this.model.chiller_month);
    this.formData.controls['chiller_year'].setValue(this.model.chiller_year);
  }

  onSubmit() {
    this.setFormModel();
    this.submitted = true;
    let startDate = this.formData.controls['start_date'].value;
    let endDate = this.formData.controls['end_date'].value;
    if (startDate != null && endDate != null) {
      this.formData.controls['start_date'].clearValidators();
      this.formData.controls['end_date'].clearValidators();
      this.formData.controls['start_date'].updateValueAndValidity();
      this.formData.controls['end_date'].updateValueAndValidity();
    }
    else {
      this.formData.controls['start_date'].setValidators([Validators.required]);
      this.formData.controls['end_date'].setValidators([Validators.required]);
      this.formData.controls['start_date'].updateValueAndValidity();
      this.formData.controls['end_date'].updateValueAndValidity();
    }
    if (this.formData.invalid) {
      return;
    }


    this.model.start_date = this.formateDate.formateDate(this.model.startDate);
    this.model.end_date = this.formateDate.formateDate(this.model.endDate);

    if (new Date(this.model.end_date) < new Date(this.model.start_date)) {
      this.toast.Error("End Date can\'t before Start date");
      return;
    }

    if (this.model.id != null) {
      this.updatePosmTemplate();
    } else {
      this.createPosmTemplate();
    }
  }

  createPosmTemplate() {
    this.loaderStart();
    this.apiService
      .post(this.apiConfig.saveVisibilityConfig, this.model)
      .subscribe((res: any) => {
        if (res.body.status) {
          this.toast.Success(res.body.data.message);
          this.id = res.body.data.id;
          this.showNextStep();
          this.getAssignedUsers();
          this.loaderDismiss();
          this.clearSuccess();
        }
      },
        (err) => {
          console.log(err);
          this.toast.Error(err);
          this.loaderDismiss();
        });
  }

  ngAfterViewInit() {
    (document.querySelector('.tabSaveBtn') as HTMLElement).style.display = 'none';
  }

  updatePosmTemplate() {
    this.loaderStart();
    this.apiService
      .put(
        this.apiConfig.updateVisibilityConfig + "?id=" + this.model.id,
        this.model
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.toast.Success(res.data.message);
          this.showNextStep();
          this.loaderDismiss();
          this.clearSuccess();
        }
      },
        (err) => {
          console.log(err);
          this.toast.Error(err);
          this.loaderDismiss();
        });
  }

  reset() {
    this.formData.reset();
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  /* wizard section start */
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    this.submittedLevels.state = args.step.index;
  }
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  getAssignedUsers() {
    this.apiService
      .getHeaders(this.apiConfig.getUploadVisiblityUsers + "?config_id=" + this.id)
      .subscribe(
        (res: any) => {
          if (res.body.data) {
            this.AssignedUsers = res.body.data;
            if (this.AssignedUsers.length > 0) {
              this.AssignedUsers.forEach(
                a => {
                  a.show = false;
                  a.statusString = a.status == 1 ? "Active" : "Inactive";
                  if (this.model.show == true) {
                    a.show = true;
                  }
                }
              )
            }
          }
        },
        (err) => {
          console.log(err);
          this.toast.Error(err);
        }
      );
  }


  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  downloadExcel() {
    this.exportExcelService.exportUserAssignment();
  }

  closeoptionModel() {
    this.tempOptionModel.close();
  }

  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }

  xlsxView(data) {
    data.apiHeaders = USER_PONITS_HEADER;
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.uploadMultiData(this.excel);
        }
      },
      (reason) => { }
    );
  }

  uploadMultiData(data) {
    data.excel_data.filter(i => {
      i["rocode"] = i["Outlet Code"]
      delete i["Outlet Code"];
      delete i.isEdit;
    })
    let payload = {
      "config_id": this.id,
      "users": data.excel_data
    }
    console.log(payload)
    this.enableUploadDiv(payload);
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.uploadVisiblityUsers,
      module: "User Assigment",
      zip: "no",
      excelname: "User Assignment Excel",
    });
  }


  changeUserStatus(item: any) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateVisiblityUserUpload + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.toast.Success(res.data.message);
        this.clearSuccess();
      },
        (err) => {
          console.log(err);
          this.toast.Error(err);
        });
  }


}
